/* eslint-disable react/jsx-no-target-blank */
import { SidebarMenuItem } from "./SidebarMenuItem";
import { useAuth } from "../../../../../app/Context/auth";
import { useLanguage } from "../../../../../app/Context/language";

const SidebarMenuMain = () => {
  const { usuario } = useAuth();
  const { t, isSpanish, isPortuguese } = useLanguage();

  return (
    <>
      <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            {t("common.portal_do_contador")}
          </span>
        </div>
      </div>

      {/* Menu em Português */}
      {isPortuguese && (
        <>
          <div className="menu-item">
            <div className="menu-content pt-8 pb-2">
              <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                Notas
              </span>
            </div>
          </div>
          <SidebarMenuItem
            to="/notas/nfe"
            icon="/media/icons/duotune/files/fil004.svg"
            title="NFe"
            fontIcon="bi-app-indicator"
          />
          <SidebarMenuItem
            to="/notas/nfce"
            icon="/media/icons/duotune/files/fil003.svg"
            title="NFCe"
            fontIcon="bi-app-indicator"
          />
          <SidebarMenuItem
            to="/notas/mdfe"
            icon="/media/icons/duotune/files/fil004.svg"
            title="MDFe"
            fontIcon="bi-app-indicator"
          />
          <SidebarMenuItem
            to="/notas/cte"
            icon="/media/icons/duotune/files/fil003.svg"
            title="CTe"
            fontIcon="bi-app-indicator"
          />
        </>
      )}

      {/* Menu em Espanhol */}
      {isSpanish && (
        <>
          <div className="menu-item">
            <div className="menu-content pt-8 pb-2">
              <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                Facturación Electrónica
              </span>
            </div>
          </div>
          <SidebarMenuItem
            to="/de/1"
            icon="/media/icons/duotune/files/fil004.svg"
            title="Factura"
            fontIcon="bi-app-indicator"
          />
          <SidebarMenuItem
            to="/de/4"
            icon="/media/icons/duotune/files/fil003.svg"
            title="Autofactura"
            fontIcon="bi-app-indicator"
          />
          <SidebarMenuItem
            to="/de/5"
            icon="/media/icons/duotune/files/fil004.svg"
            title="Nota de Crédito"
            fontIcon="bi-app-indicator"
          />
          <SidebarMenuItem
            to="/de/6"
            icon="/media/icons/duotune/files/fil003.svg"
            title="Nota de Débito"
            fontIcon="bi-app-indicator"
          />
          <SidebarMenuItem
            to="/de/7"
            icon="/media/icons/duotune/files/fil004.svg"
            title="Nota de Remisión"
            fontIcon="bi-app-indicator"
          />
        </>
      )}

      <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            {t("menu.cadastros")}
          </span>
        </div>
      </div>
      <SidebarMenuItem
        to="/cadastros/produtos"
        icon="/media/icons/duotune/ecommerce/ecm010.svg"
        title={t("menu.produtos")}
        fontIcon="bi-app-indicator"
      />

      {isPortuguese && (
        <>
          <div className="menu-item">
            <div className="menu-content pt-8 pb-2">
              <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                {t("menu.consultas")}
              </span>
            </div>
          </div>
          <SidebarMenuItem
            to="/consultas/tributacao"
            icon="/media/icons/duotune/ecommerce/ecm010.svg"
            title={t("menu.consulta_tributaria")}
            fontIcon="bi-app-indicator"
          />{" "}
        </>
      )}

      {/* Arquivo Sped - apenas em Português e para sistema SCA */}
      {isPortuguese && usuario.sistema === "SCA" && (
        <>
          <div className="menu-item">
            <div className="menu-content pt-8 pb-2">
              <span className="menu-section text-muted text-uppercase fs-8 ls-1">
                Arquivo Sped
              </span>
            </div>
          </div>
          <SidebarMenuItem
            to="/sped/fiscal"
            icon="/media/icons/duotune/files/fil004.svg"
            title="Sped Fiscal"
            fontIcon="bi-app-indicator"
          />
        </>
      )}
    </>
  );
};

export { SidebarMenuMain };
